export default {
  documentTemplates: [],
  documentTemplate: undefined,
  templateTypes: [
    'Specification Sheet',
    'Instructions for Use',
    'Medinox DoC',
  ],
};
